/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const MoreOptionsDotIcon = ({ width = 3, height = 13, color = '#f7f9fa', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 3 13' fill={color} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M2.75 1.75317C2.75 2.44353 2.19036 3.00317 1.5 3.00317C0.809644 3.00317 0.25 2.44353 0.25 1.75317C0.25 1.06282 0.809644 0.503174 1.5 0.503174C2.19036 0.503174 2.75 1.06282 2.75 1.75317Z' />
    <path d='M2.75 11.2532C2.75 11.9435 2.19036 12.5032 1.5 12.5032C0.809644 12.5032 0.25 11.9435 0.25 11.2532C0.25 10.5628 0.809644 10.0032 1.5 10.0032C2.19036 10.0032 2.75 10.5628 2.75 11.2532Z' />
    <path d='M1.5 7.75317C2.19036 7.75317 2.75 7.19353 2.75 6.50317C2.75 5.81282 2.19036 5.25317 1.5 5.25317C0.809644 5.25317 0.25 5.81282 0.25 6.50317C0.25 7.19353 0.809644 7.75317 1.5 7.75317Z' />
  </svg>
);

export default MoreOptionsDotIcon;
